/**
 * Trạng thái của form
 */
export default {
  Female: 1,
  Male: 2,
  Other: 3,
};
